import { createRequest } from 'utils/request';

import type { paths } from 'schemas/schema';

type QuizPreviousResult = paths['/trivia/{slug}/results/{uuid}/'];

const getTriviaPreviousResult = createRequest<QuizPreviousResult>('/pc/quiz/{slug}/results/{uuid}/');

export default getTriviaPreviousResult;
